export default () => ({
  open: false,

  openModal() {
    this.open = true;
    document.body.classList.add('stop-scrolling')
  },

  closeModal() {
    this.open = false;
    document.body.classList.remove('stop-scrolling');
  }

});
